export const transformDate = (date: string) => {
  if (date) {
    const parsedDate = date.split('/');
    return `${parsedDate[2]}-${parsedDate[0]}-${parsedDate[1]}T00:00:00.000Z`;
  } else {
    return null;
  }
};